import { render } from "./comunicaciones_lista.vue?vue&type=template&id=c4818a96"
import script from "./comunicaciones_lista.vue?vue&type=script&lang=js"
export * from "./comunicaciones_lista.vue?vue&type=script&lang=js"

import "./comunicaciones_lista.vue?vue&type=style&index=0&id=c4818a96&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__